import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.bundle";
import "react-credit-cards/es/styles-compiled.css";
import 'react-phone-input-2/lib/style.css';
import "./documentsForm.css"

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./documents.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import { BrowserRouter } from "react-router-dom";
import watchers from "./Store/Sagas";
import reducer from "./Store/Reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const saga = createSagaMiddleware();
const store = createStore(
	reducer,
	composeEnhancers(applyMiddleware(thunk, saga)),
);

saga.run(watchers);
window.Storage = store;

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>,
	document.getElementById("root"),
);

reportWebVitals();
